export const SET_BAYS = 'SET_BAYS'
export const SET_BAY = 'SET_BAY'
export const UPDATE_BAY = 'UPDATE_BAY'
export const UPDATE_SLOT = 'UPDATE_SLOT'
export const INIT_BAY = 'INIT_BAY'
export const SET_SLOTS = 'SET_SLOTS'
export const SET_SLOT = 'SET_SLOT'
export const RESET_BAYS = 'RESET_BAYS'



// WEBPACK FOOTER //
// ./src/store/modules/bays/types.js